import { LOG_IN, LOG_OUT } from '../actions/account'

const defaultState = {
    name: '',
    email: '',
    permissions: {
        canDownloadFeedback: false,
        canDownloadErrors: false
    }
}

export default (state = defaultState, action) => {
    const { type } = action

    switch (type) {
        case LOG_IN:
            return action.userInfo
        case LOG_OUT:
            return defaultState
        default:
            return state
    }
}
